import type { ReactElement } from 'react';
import React from 'react';
import { Banner, FloatingBannerImage } from '@noths/polaris-client-ribbons-design-system';

import * as styles from './LinksBanner.styles';

export interface LinksBannerProps {
  subHeading?: string;
  backgroundColor: string;
  imageUrl: string;
  imageAlt: string;
  children: ReactElement;
}

export const LinksBanner = ({
  subHeading,
  backgroundColor,
  imageUrl,
  imageAlt,
  children,
}: LinksBannerProps) => {
  const defaultImageHeight = 300;
  const defaultImageWidth = 300;

  return (
    <div css={styles.bottomOffsetImageMarginLinksBanner}>
      <Banner backgroundColor={backgroundColor} roundedCorners>
        <div css={styles.linksBanner}>
          <div css={styles.imageWrapper}>
            <FloatingBannerImage
              images={[{ src: imageUrl, width: defaultImageWidth }]}
              imageAlt={imageAlt}
              imageWidth={defaultImageWidth}
              imageHeight={defaultImageHeight}
              offset="bottom"
              imageAspectRatio="1 / 1"
            />
          </div>
          {subHeading && <p css={styles.subHeading}>{subHeading}</p>}
          <div css={styles.content}>{children}</div>
        </div>
      </Banner>
    </div>
  );
};
